import React from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import { FilterContainer, SearchDropdownField, SearchField } from '../../components';
import { WorkingTeamListFilter } from '../../../state/workingTeam';
import { IFilterContainerConfigProps } from '../../components/FilterContainer';

const WorkingTeamFilter: React.FC<IFilterContainerConfigProps<WorkingTeamListFilter>> = (
  props,
) => {
  return (
    <FilterContainer
      {...props}
      render={(filterProps) => {
        const { localFilter, handleChangeFilter } = filterProps;
        return (
          <Grid container spacing={1}>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                filterKey="Name.startsWith"
                filters={localFilter}
                label="Name"
                onChange={handleChangeFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                filterKey="Owner.FullNameWithUserName.Contains"
                filters={localFilter}
                label="Owner"
                onChange={handleChangeFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchDropdownField
                label="Status"
                filterKey={'Active.EqualsTo'}
                filters={localFilter}
                onChange={handleChangeFilter}
                id="status"
              >
                <MenuItem value={''}>All</MenuItem>
                <MenuItem value={'true'}>Active</MenuItem>
                <MenuItem value={'false'}>Inactive</MenuItem>
              </SearchDropdownField>
            </Grid>
          </Grid>
        );
      }}
    />
  );
};

export default WorkingTeamFilter;
